import type { FeatureGroup } from '../../../../types';
import { ASSETS_FEATURE_GROUP } from '../group';

export const ASSETS_TYPOGRAPHY_FEATURE_GROUP: FeatureGroup = {
  guid: 'e7b3c920-1f5d-4a86-c974-2a8b3d6eff00',
  name: 'assets:typography',
  description: 'Typography asset features — fonts, sizes, and typographic settings',
  product: 'account',
  parentGuid: ASSETS_FEATURE_GROUP.guid,
};
